import React, { useEffect, useRef, useState } from 'react';
import descargarDocumento from '../../services/DescargarDocumento';

/**
 * Documento descargable. Se renderiza como <span> y no como <a>: el front no
 * conoce la URL del archivo, sólo los identificadores con los que le pide el
 * documento al backend, así el path nunca queda expuesto.
 */
const LinkDocumento = ({ params, nombre }) => {
  const [descargando, setDescargando] = useState(false);
  const [error, setError] = useState('');
  const montado = useRef(true);

  useEffect(() => {
    return () => {
      montado.current = false;
    };
  }, []);

  const onClick = async (e) => {
    e.preventDefault();
    if (descargando) {
      return;
    }
    setDescargando(true);
    setError('');
    const resultado = await descargarDocumento(params, nombre);
    if (montado.current) {
      setDescargando(false);
      setError(resultado.ok ? '' : resultado.mensaje);
    }
  };

  return (
    <>
      <span
        className={'link-documento' + (descargando ? ' is-descargando' : '')}
        onClick={onClick}
        onKeyPress={onClick}
        role="button"
        tabIndex="0"
        title={descargando ? 'Descargando ' + nombre : 'Descargar ' + nombre}
        aria-label={'Descargar ' + nombre}
      >
        <i className={descargando ? 'fas fa-spinner fa-spin' : 'fas fa-download'} />
      </span>
      {error !== '' && <div className="error-documento">{error}</div>}
    </>
  );
};

export default LinkDocumento;
